import React, {Component, Fragment} from 'react';
import axios from "axios";
import PhoneIcon from '@material-ui/icons/Phone';
import SmsIcon from '@material-ui/icons/Sms';

import {getLocalizationLanguageCode} from "../../../util/localization";
import {getLocaleDateTimeString} from "../../../util/utilMethods";
import '../../../chat.css';

import MessageType from '../../../config/constants/MessageTypeEnum';
import Message from './message/Message'
import ChatFeedback from "./chatFeedback/ChatFeedback";
import ChatQuestionTypeEnum from "../../../config/constants/ChatQuestionTypeEnum";
import LineBreakTypeEnum from "../../../config/constants/LineBreakTypeEnum";
import Setup from "../../../config/Setup";
import IntegrationTypeEnum from "../../../config/constants/IntegrationTypeEnum";
import LayoutTypeEnum from "../../../config/constants/LayoutTypeEnum";

/**
 * Class that shows a single speechbubble.
 */
class SpeechBubble extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hover: false
        };
    }

    /**
     * Returns a list of rows with all the visible messages.
     */
    getMessageRowList = () => {
        const {speechBubble} = this.props;
        
        if (!speechBubble.messageList) {
            return [];
        }

        let rowList = [];
        let messageList = [];

        speechBubble.messageList.forEach(message => {
            if (!message.hidden) {
                messageList.push(message);
            }
        });

        let rowMessageList = [];
        for(let i = 0; i < messageList.length; i++) {
            let lineBreak = messageList[i].messageType === MessageType.suggestion ? messageList[i].message.lineBreak : messageList[i].lineBreak;
            rowMessageList.push(messageList[i]);

            if (lineBreak !== false || i === messageList.length - 1) {
                let row = {
                    messageList: rowMessageList
                };

                rowList.push(row);
                rowMessageList = [];
            }
        }

        return rowList;
    };

    speechBubbleClicked = () => {
        const {speechBubble} = this.props;
        
        let suggestion = speechBubble.suggestion;

        if (suggestion && !speechBubble.disabled) {
            this.props.sendIntent(suggestion.intentToTriggerId, ChatQuestionTypeEnum.suggestion, null, speechBubble, false);
        }
    };

    speechBubbleToggleHover = () => {
        const hover = !this.state.hover;
        this.setState({hover});
    };

    downloadFile = (url) => {
        return axios
            .post((process.env.NODE_ENV === 'development' ? Setup.apiEndpointDev : process.env.REACT_APP_TEST_BUILD ? Setup.apiEndpointTest : Setup.apiEndpointProd)+ 'storage/getTemporaryDownloadUrl/token/' + this.props.token , {url:url })
            .then(response => {
                window.open(response.data);
            })
            .catch(error => {
                throw error;
            })
    };


    render() {
        const localizationCode = getLocalizationLanguageCode(this.props.language ? this.props.language.languageCode : null)
        const {speechBubble, chatConfig, showAvatar, spectatorMode, layoutMode} = this.props;

                return(
              <div className={(layoutMode === LayoutTypeEnum.searchBot ? 'search-bot-speech-bubble-container' : 'speech-bubble-container') + (speechBubble.isUser ? ' user-speech-bubble-container' : ' bot-speech-bubble-container')}
                   style={{maxWidth: this.props.welcomePreviewEnabled ? '100%' : null}}>
                {(!speechBubble.isUser && chatConfig.logoUrl !== null && speechBubble.suggestion == null &&
                    speechBubble.messageList.some(m => m.messageType === MessageType.card) === false) && layoutMode !== LayoutTypeEnum.searchBot  ?
                
                   <div className={'speech-bubble-avatar-container'} style={{ minWidth: speechBubble.lineBreakType === LineBreakTypeEnum.carousel ? "5px":null }}>
                       { (speechBubble.index === 0 || speechBubble.isGpt == true) &&  showAvatar === true  && speechBubble.lineBreakType !== LineBreakTypeEnum.carousel ?
                          <img width="35px" height="35px" className={'speech-bubble-avatar'} src={speechBubble.avatarUrl && speechBubble.isGpt == false ? speechBubble.avatarUrl : chatConfig.logoUrl} alt={'avatar'}/>
                          : null
                       }
                    </div>
                : null}
                  <div className={layoutMode === LayoutTypeEnum.searchBot ? 'search-bot-speech-bubble-content-wrapper'  : 'speech-bubble-content-wrapper'} style={
                      {
                          font: chatConfig ? chatConfig.font : null
                      }
                  }>
                      {layoutMode !== LayoutTypeEnum.searchBot && speechBubble.index === 0 && !speechBubble.botWriting && !speechBubble.suggestion && (!speechBubble.isUser || this.props.spectatorMode) && speechBubble.lineBreakType !== LineBreakTypeEnum.carousel ?
                          <div className={'speech-bubble-datetime-container'}>
                              {(!speechBubble.isUser && (speechBubble.avatarName || chatConfig.chatbotName) ?
                                  (speechBubble.avatarName ? speechBubble.avatarName : chatConfig.chatbotName) + ' ' : '') +
                              (speechBubble.isUser ? getLocaleDateTimeString(speechBubble.dateTimeUtc, false, localizationCode) : getLocaleDateTimeString(speechBubble.dateTimeUtc, true, localizationCode))}
                          </div> : null
                      }

                      <div className={(layoutMode === LayoutTypeEnum.searchBot ? 'search-bot-speech-bubble-content-container' : 'speech-bubble-content-container') + (speechBubble.displayBackground === false ? '' :
                          (speechBubble.isUser ? (layoutMode === LayoutTypeEnum.searchBot ? ' search-bot-user-speech-bubble-content-container' : ' user-speech-bubble-content-container') : ' bot-speech-bubble-content-container')) +
                      (speechBubble.disabled ? ' disabled-speech-bubble-content-container' :
                          speechBubble.suggestion ? ' suggestion-speech-bubble-content-container' : '')}


                           style={(speechBubble.isUser && chatConfig &&
                               speechBubble.displayBackground !== false) ?
                               {
                                   backgroundColor: chatConfig.speechBubbleUserColor,
                                   color: chatConfig.fontUserColor,
                                   border: chatConfig.speechBubbleBorderColor ? '1px solid ' + chatConfig.speechBubbleBorderColor : null
                               } :
                               ( !speechBubble.isUser && chatConfig && !speechBubble.suggestion &&
                                   speechBubble.displayBackground !== false) ?
                                   {
                                       backgroundColor: chatConfig.speechBubbleBotColor,
                                       color: chatConfig.fontBotColor,
                                       border: chatConfig.speechBubbleBorderColor ? '1px solid ' + chatConfig.speechBubbleBorderColor : null
                                   } :
                                   speechBubble.suggestion ?
                                       {
                                           backgroundColor: this.state.hover ? chatConfig.suggestionSpeechBubbleHoverColor ?
                                               chatConfig.suggestionSpeechBubbleHoverColor : chatConfig.speechBubbleBotColor :
                                               chatConfig.suggestionSpeechBubbleColor ? chatConfig.suggestionSpeechBubbleColor : null,
                                           color: this.state.hover ? chatConfig.suggestionFontHoverColor ?
                                               chatConfig.suggestionFontHoverColor : chatConfig.fontBotColor :
                                               chatConfig.suggestionFontColor ? chatConfig.suggestionFontColor : null,
                                           borderColor: chatConfig.suggestionBorderColor ? chatConfig.suggestionBorderColor : chatConfig.speechBubbleBotColor
                                       } : null}
                           onClick={this.speechBubbleClicked} onMouseEnter={this.speechBubbleToggleHover} onMouseLeave={this.speechBubbleToggleHover}>

                          {this.props.spectatorMode && this.props.speechBubble.isUser && this.props.speechBubble.integrationType > 0 ?
                              <div style={{position: 'relative', color: 'rgba(0, 0, 0, 0.54)'}}>
                                  <div style={{position: 'absolute', right: '-21px', top: '-4px'}}>

                                      {/*{this.props.speechBubble.integrationType === IntegrationTypeEnum.widget ?*/}
                                      {/*    <WidgetsIcon/> : null}*/}

                                      {/*{this.props.speechBubble.integrationType === IntegrationTypeEnum.facebook ?*/}
                                      {/*    <FacebookIcon width={"22px"} fill={"rgba(0, 0, 0, 0.54)"}/> : null}*/}

                                      {this.props.speechBubble.integrationType === IntegrationTypeEnum.phoneCall ?
                                        <PhoneIcon/> : null}

                                      {this.props.speechBubble.integrationType === IntegrationTypeEnum.sms ?
                                          <SmsIcon/> : null}

                                  </div>
                              </div> : null}

                          {this.getMessageRowList().map((row, index) => (
                              <div className={layoutMode === LayoutTypeEnum.searchBot ? 'search-bot-message-row' : 'message-row'} key={index}>
                                  {row.messageList.map((message, index) => (
                                      <Message layoutMode={layoutMode} hover={this.state.hover} isSuggestion={speechBubble.suggestion!=null} downloadFile={(url)=>this.downloadFile(url)} message={message} isUser={speechBubble.isUser} sendMessage={this.props.sendMessage} chatConfig={chatConfig} key={index}/>
                                  ))}
                              </div>
                          ))}

                      </div>
                      <div className={"chat-info-container"}>
                          <div className={"chat-info-feedback-container"}>
                              { speechBubble.isGpt == 'true' || (speechBubble.chatQuestionId && layoutMode === LayoutTypeEnum.chatBot)  &&
                                  <ChatFeedback
                                      speechBubble={speechBubble}
                                      chatConfig={chatConfig}
                                      sendChatResponseFeedback={this.props.sendChatResponseFeedback}
                                      spectatorMode={this.props.spectatorMode}
                                      layoutMode={layoutMode}
                                  />
                              }
                              {layoutMode === LayoutTypeEnum.searchBot && this.props.lastRow === true && speechBubble.chatResponseId && !speechBubble.isUser &&
                                  <Fragment>
                                      <div className={"chat-feedback-label"}>
                                          Hvordan vil du bedømme svaret?
                                      </div>
                                      <ChatFeedback
                                          speechBubble={speechBubble}
                                          chatConfig={chatConfig}
                                          sendChatResponseFeedback={this.props.sendChatResponseFeedback}
                                          spectatorMode={this.props.spectatorMode}
                                          layoutMode={layoutMode}
                                      />
                                  </Fragment>
                              }
                          </div>
                          {layoutMode === LayoutTypeEnum.searchBot && this.props.lastRow && !speechBubble.botWriting && (!speechBubble.isUser || this.props.spectatorMode) && speechBubble.lineBreakType !== LineBreakTypeEnum.carousel ?
                              <div className={'search-bot-speech-bubble-datetime-container'}>
                                  {getLocaleDateTimeString(speechBubble.dateTimeUtc, false, localizationCode)}
                              </div> : null
                          }
                      </div>

                  </div>
            </div>
        );
    }
}

export default SpeechBubble;
